import { render, staticRenderFns } from "./page-pagination.vue?vue&type=template&id=018de3b0"
import script from "./page-pagination.vue?vue&type=script&lang=js"
export * from "./page-pagination.vue?vue&type=script&lang=js"
import style0 from "./page-pagination.vue?vue&type=style&index=0&id=018de3b0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('018de3b0')) {
      api.createRecord('018de3b0', component.options)
    } else {
      api.reload('018de3b0', component.options)
    }
    module.hot.accept("./page-pagination.vue?vue&type=template&id=018de3b0", function () {
      api.rerender('018de3b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/page-pagination.vue"
export default component.exports